<template>
<div class="box6-page">
  <div class="fcp-title">合理的学习路径才是通过认证的<br/>唯一标准</div>
  <div class="box6-stit stit-01">
    <span>学习路径一</span>
    <span>系统性自学，2个月平稳掌握</span>
  </div>
  <div class="cont-box1">
    <div class="left"></div>
    <ul class="right">
      <li v-for="(item, index) in list" :key="index">
        <h2>{{ item.title }}</h2>
        <span>{{ item.tips }}</span>
        <p v-html="item.text"></p>
      </li>
    </ul>
  </div>
  <div class="btn-cont">
    <div class="btn" @click="openCourse(1)">报名考试</div>
    <div class="btn" @click="openMask(1)">在校生报名考试</div>
  </div>
  <div class="popup-box">
    <p>“报名考试”指只考试无课程服务。考前需先到帆软官网<br/>自学，缴费后扫二维码领报名兑换券，在校生报名直减<br/> <span>100元</span></p>
  </div>
  <div class="box6-page2">
    <div class="box6-stit stit-02">
      <span>学习路径二</span>
      <span>报名配套课，18小时快速精通</span>
    </div>
    <div class="cont-box2">
      <h2>《FCP报表交付工程师认证·精讲课》</h2>
      <ul>
        <li v-for="(item, index) in list2" :key="index" v-html="item"></li>
      </ul>
    </div>
    <div class="btn-cont btn-cont2">
      <div class="btn2" @click="openCourse(2)">
        <p>报名课程</p>
        <span>（含认证考试）</span>
      </div>
      <div class="btn2" @click="openMask(2)">
        <p>在校生报名课程</p>
        <span>（含认证考试）</span>
      </div>
    </div>
    <div class="popup-box">
      <p>“报名课程”指认证考试+15小时课程辅导+群服务。考<br/>前再享3小时精讲课，缴费后扫二维码领报名兑换券，<br/>在校生报名直减 <span>100元</span></p>
    </div>
  </div>
  <div class="box6-page3">
    <div class="cont-box3">
      <div class="top">
        <p>如果您是传智老学员，请</p>
        <div></div>
        <p>联系自己</p>
      </div>
      <p class="bottom">的班主任/学科老师报名，享内部优惠价！</p>
    </div>
  </div>
</div>
</template>

<script>
  export default {
    name: '',
    data() {
      return {
        list:[
          {
            title: '入门学习',
            tips: '预计1-2天',
            text: '了解产品实现效果以及帆软各类资源如<br/>何使用'
          },
          {
            title: '夯实基础',
            tips: '预计5-20天',
            text: '掌握系统管理所需基本配置，以及报表<br/>开发所需功能点的基本操作。'
          },
          {
            title: '进阶实践',
            tips: '预计1-2个月',
            text: '掌握在实践过程中进阶功能操作和各类<br/>规范，并通过业务场景示例进一步了解<br/>业务逻辑。'
          }
        ],
        list2: [
          '博学谷&帆软独家合作，全网首个独立研发认<br/>证培训课程',
          '15小时培训课+3小时考前精讲课，企业真实场<br/>景为例，让你认证及工作，统统用得上',
          '课程涵盖FCP考前真题精讲以及企业级报表开<br/>发真实流程和项目体验',
          '学习认证配套课程，通过率可达90%，0基础<br/>可学'
        ]
      }
    },
    methods:{
      // 跳转课程详情
      openCourse(type){
        window.location.href= type==1? 'https://m.boxuegu.com/course/detail-10016' : 'https://m.boxuegu.com/course/detail-10014'
      },
      // 打开认证
      openMask(type){
        const btnName = type === 1 ? '在校生报名考试' : '在校生报名课程'
        this.mai("帆软FCP认证&培训-传智",btnName,0,null)
        // 2023.11.9 跳咨询，后面改成跳页面
        this.clickZiXun()

        // localStorage.setItem('qrcodeType', type)
        // this.$emit('open')
      }
    }
  }
</script>

<style lang="scss" scoped>
.box6-page{
  padding-top: 80px;
  background-image: url(../../../assets/coursePage/fcp/box6/box6-bg.png);
  background-size: cover;
  .box6-stit{
    height: 100px;
    margin: 32px auto 0;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    background-size: 100% 100%;
    span{
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #2C4875;
      line-height: 48px;
    }
  }
  .stit-01{
    width: 644px;
    background-image: url(../../../assets/coursePage/fcp/box6/stit-bg1.png);
    padding: 22px 44px 0 50px;
  }


  .cont-box1{
    margin-top: 8px;
    display: flex;
    padding-left: 58px;
    padding-right: 12px;
    .left{
      min-width: 54px;
      margin-top: 16px;
      width: 54px;
      height: 834px;
      background-image: url(../../../assets/coursePage/fcp/box6/left-bg.png);
      background-size: 100% 100%;
    }
    .right{
      width: 642px;
      min-width: 642px;
      transform: translateX(-15px);
      li{
        width: 642px;
        height: 284px;
        background-image: url(../../../assets/coursePage/fcp/box6/card-01.png);
        background-size: 100% 100%;
        padding: 64px 0 0 90px;
        box-sizing: border-box;
        position: relative;
        h2{
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #1D2129;
          line-height: 48px;
        }
        p{
          margin-top: 16px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #4E5969;
          line-height: 44px;
        }
        span{
          position: absolute;
          top: 60px;
          right: 36px;
          width: 220px;
          height: 56px;
          background: linear-gradient(270deg, rgba(241,245,255,0) 0%, rgba(210,237,255,0.48) 51%, rgba(228,246,255,0.26) 74%, rgba(248,255,255,0) 100%);
          border-radius: 12px;
          border: 2px solid;
          border-image: linear-gradient(270deg, rgba(255, 255, 255, 0), rgba(210, 236, 255, 1), rgba(255, 255, 255, 0)) 2 2;
          text-align: center;
          font-size: 25.5px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #4BABF5;
          line-height: 56px;
        }
      }
      li:nth-of-type(2){
        margin-top: -8px;
      }
      li:last-child{
        margin-top: -8px;
        height: 324px;
        background-image: url(../../../assets/coursePage/fcp/box6/card-03.png);
      }
    }
  }

  .btn-cont{
    margin: 24px auto 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .btn{
      width: 326px;
      height: 96px;
      text-align: center;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #FFFFFF;
      line-height: 96px;
      background: linear-gradient(270deg, #71C1FF 0%, #028DF9 100%);
      border-radius: 48px;
      &:last-child{
        margin-left: 34px;
      }
    }
  }

  .popup-box{
    width: 698px;
    height: 180px;
    padding: 34px 0 0 36px;
    margin: 24px auto 0;
    background-image: url(../../../assets/coursePage/fcp/box6/pic-popup-bg.png);
    background-size: 100% 100%;
    box-sizing: border-box;
    p{
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4E5969;
      line-height: 44px;
      span{
        font-family: PingFangSC-Semibold, PingFang SC;
        color: #FF4137;
        font-weight: 600;
        font-size: 30px;
      }
    }
  }
  .box6-page2{
    margin-top: 80px;
    padding-top: 64px;
    padding-bottom: 80px;
    background: linear-gradient(180deg, rgba(255,255,255,0.24) 0%, rgba(255,255,255,0.13) 47%, rgba(255,255,255,0.24) 100%);
    .stit-02{
      width: 654px;
      margin-top: 0px;
      background-image: url(../../../assets/coursePage/fcp/box6/stit-bg1.png);
      padding: 22px 46px 0 50px;
    }
    .cont-box2{
      width: 686px;
      height: 556px;
      margin: 24px auto 0;
      background-color: #FFFFFF;
      box-shadow: 0px 4px 40px 0px rgba(0,0,0,0.04);
      border-radius: 32px;
      background-image: url(../../../assets/coursePage/fcp/box6/box6-cont2-bg.png);
      background-size: 830px 560px;
      box-sizing: border-box;
      padding: 40px 0 0 46px;
      h2{
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #24375C;
        line-height: 52px;
      }
      ul{
        margin-top: 24px;
        li{
          padding-left: 34px;
          position: relative;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #24375C;
          line-height: 44px;
          margin-top: 16px;
          &::after{
            position: absolute;
            top: 10px;
            left: 0;
            width: 18px;
            height: 18px;
            content: "";
            background-image: url(../../../assets/coursePage/fcp/box6/icon-cont2-li.png);
            background-size: 100% 100%;
          }
          &:first-child{
            margin-top: 0;
          }
        }
      }
    }
    .btn-cont2{
      margin-top: 44px;
      .btn2{
        width: 326px;
        height: 96px;
        background: linear-gradient(36deg, #846CE6 0%, #BAA5F4 100%);
        border-radius: 48px;
        padding-top: 6px;
        box-sizing: border-box;
        p{
          text-align: center;
          font-size: 32px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 48px;
        }
        span{
          display: block;
          text-align: center;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #FFFFFF;
          line-height: 36px;
        }
        &:nth-of-type(2){
          margin-left: 34px;
        }
      }
    }
  }
  .box6-page3{
    padding: 40px 0 32px;
    .cont-box3{
      width: 774px;
      height: 268px;
      margin-left: -12px;
      background-image: url(../../../assets/coursePage/fcp/box6/box6-cont3-bg.png);
      background-size: 100% 100%;
      padding: 78px 0 0 92px;
      box-sizing: border-box;
      .top{
        display: flex;
        div{
          width: 42px;
          height: 44px;
          margin: 0 10px 0 16px;
          background-image: url(../../../assets/coursePage/fcp/box6/icon-phone.png);
          background-size: 100% 100%;
        }
      }
      .bottom{
        margin-top: 16px;
      }
      p{
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1F375F;
        line-height: 44px;
      }
    }
  }
}
</style>